import { Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';
import { ArrowRIcon } from 'components';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  onClick?: () => void;
  icon?: React.ReactNode;
  disabled?: boolean;
};

const NextButton = (props: Props) => {
  const { sx, children, icon, onClick, disabled } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (disabled) return;
    onClick && onClick();
  };

  return (
    <Button
      sx={{
        width: '300px',
        height: '50px',
        mx: 'auto',
        my: 0,
        p: 1,
        textAlign: 'center',
        bgcolor: baseColors.orange,
        borderRadius: '25px',
        boxShadow: 2,
        position: 'relative',
        ...sx
      }}
      onClick={handleClick}
      disabled={!!disabled}
    >
      <Typography
        variant="subtitle1"
        sx={{
          color: baseColors.white
        }}
      >
        {children ? children : '次へ'}
      </Typography>
      {icon ? icon : <ArrowRIcon style={{ position: 'absolute', right: 20 }} />}
    </Button>
  );
};

export default NextButton;
